const wsMsgEvent = {
  create(bus) {
    this.bus = bus
    this.initEventListener()
  },
  initEventListener() {
    const _this = this
    window.addEventListener(
      'message',
      (e) => {
        console.log(e.data, 'message:postmessage')
        const params = e.data
        if (params.type === 'pkTongXunlu') {
          _this.bus.$emit('pkTongXunlu', params.data)
        }
        if (params.type === 'openVideoSurveillance') {
          const el = document.querySelector(`#${params.videoId}`)
          console.log(el, 'el')
          el && el.click()
          console.log(e, '视频监控摄像头msg')
        }
        // if (params.type === 'runningPhone') {
        //   const el = document.querySelector(`#${params.memberId}`)
        //   el && el.click()
        // }
      },
      true,
    )
  },
}

export default wsMsgEvent
